import {
  CUSTOMER_LOYALTY_SUMMARY_REQUESTING,
  GET_CUSTOMER_LOYALTY_SUMMARY_SUCCESS,
  RESET_CUSTOMER_LOYALTY_SUMMARY_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  isFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_CUSTOMER_LOYALTY_SUMMARY_ISFETCHING: {
      return {
        ...state,
        isFetching: false
      };
    }
    case CUSTOMER_LOYALTY_SUMMARY_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case GET_CUSTOMER_LOYALTY_SUMMARY_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        isFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
